<template>
  <div class="content">
    <div class="container-fluid max-w-md mx-auto">
      <h3 class="text-center">Why Advertise at Sydney Markets?</h3>
      <div class="row ad-copy">
        <p>
          Sydney Markets offer a unique opportunity to advertise to hundreds of
          small businesses with over 5 000 employees and millions of visitors
          annually.
        </p>

        <p>
          Centred at the heart of Homebush West, Sydney Markets Flemington
          offers a great return on your investment, with unparalleled
          advertising rates in high traffic areas.
        </p>
      </div>

      <div class="text-center">
        <a
          class="btn btn-primary btn-lg text-white mt-3"
          href="https://d3gfecrcby3rzr.cloudfront.net/2021_Sydney_Markets_Advertising_Deck.pdf"
          >Download Information PDF</a
        >
      </div>
      <div class="d-flex flex-row justify-content-around flex-wrap">
        <div class="ad-stat border-primary">
          <h4 class="text-primary">7 MILLION</h4>
          <span>visitors annually</span>
        </div>
        <div class="ad-stat border-primary">
          <h4 class="text-primary">3.5 MILLION</h4>
          <span>vehicles annually</span>
        </div>
        <div class="ad-stat border-primary">
          <h4 class="text-primary">OVER 700</h4>
          <span>small businesses</span>
        </div>
        <div class="ad-stat border-primary">
          <h4 class="text-primary">OVER 5000</h4>
          <span>people work at Sydney Markets</span>
        </div>
      </div>
      <div class="ad-copy">
        <p class="emphasis border-primary">
          SYDNEY MARKETS
          <span class="text-primary"
            >IS THE LARGEST FRESH FRUIT AND VEGETABLE WHOLESALE MARKET IN
            AUSTRALIA SYDNEY</span
          >
        </p>

        <p class="emphasis border-primary">
          <span class="text-primary">SYDNEY MARKETS OPERATES</span> 24 HOURS A
          DAY, <span class="text-primary">SEVEN DAYS A WEEK</span>
        </p>

        <p>
          For further information or to book an advertising space please Email
          <a href="mailto:marketing@sydneymarkets.com"
            >marketing@sydneymarkets.com</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Advertising"
};
</script>

<style scoped>
.ad-stat {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 180px;
  justify-content: center;
  text-align: center;
  margin: 50px 0;
  padding: 10px;
  border: 2px solid;
  border-radius: 1000px;
}

.emphasis {
  border: 1px solid;
  margin: 20px;
  padding: 10px;
  max-width: 90%;
  font-weight: bold;
}

.ad-copy {
  line-height: 2em;
}

.ad-copy p {
  margin-bottom: 1em;
}

.max-w-md {
  max-width: 900px;
}
</style>
